/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const updateEventSubscriptionPathParamsSchema = z.object({
    "id": z.string().describe("Event subscription identifier")
    })

export const updateEventSubscriptionHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Event subscription owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Event subscription updated
 */
export const updateEventSubscription200Schema = z.object({
    "id": z.string(),
"userId": z.string(),
"name": z.string(),
"targetUrl": z.string(),
"headers": z.nullable(z.object({
    
    }).catchall(z.string())),
"eventTypes": z.array(z.enum(["contact.event.detected", "contact.summary.completed"])),
"enabled": z.boolean(),
"lastSuccessAt": z.nullable(z.iso.datetime()),
"lastFailureAt": z.nullable(z.iso.datetime()),
"lastErrorMessage": z.nullable(z.string()),
"consecutiveFailureCount": z.int().min(-9007199254740991).max(9007199254740991),
"autoDisabledAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const updateEventSubscription400Schema = z.any()

/**
 * @description Event subscription not found
 */
export const updateEventSubscription404Schema = z.any()

export const updateEventSubscriptionMutationRequestSchema = z.object({
    "name": z.optional(z.string().min(1).max(80)),
"targetUrl": z.optional(z.url()),
"eventTypes": z.optional(z.array(z.enum(["contact.event.detected", "contact.summary.completed"])).min(1)),
"headers": z.object({
    
    }).catchall(z.string().max(2048)).nullish(),
"enabled": z.optional(z.boolean())
    })

export const updateEventSubscriptionMutationResponseSchema = z.lazy(() => updateEventSubscription200Schema)